module.exports = __webpack_public_path__ + "static/assets/86eb92c49b19cd572a1f7b36f1a41245.gif";